<template>
    <div class="a-auto-complete">
        <template v-if="label">
            <span class="label">
                {{ label }}<span v-if="required" class="red">*</span>
            </span>
        </template>

        <template v-if="validation">
            <ValidationProvider
                v-slot="{ errors }"
                v-bind="validationConfig"
                mode="eager"
            >
                <AutoComplete
                    ref="input"
                    v-model="localValue"
                    :class="{
                        'has-errors': errors.length > 0,
                    }"
                    v-bind="$attrs"
                    @on-blur="onBlurHandler"
                    @on-search="onSearchHandler"
                />
                <span class="error">{{ errors[0] }}</span>
            </ValidationProvider>
        </template>
        <template v-else>
            <AutoComplete ref="input" v-model="localValue" v-bind="$attrs" />
        </template>
    </div>
</template>

<script>
import { AutoComplete } from 'view-design'
import { ValidationProvider } from 'vee-validate'

export default {
    name: 'AAutoComplete',
    components: {
        AutoComplete,
        ValidationProvider,
    },
    props: {
        value: {
            type: [String, Number],
            required: true,
        },
        validation: {
            type: Boolean,
            default: false,
        },
        validationConfig: {
            type: Object,
            default: () => {},
        },
        label: {
            type: String,
            default: '',
        },
        required: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        localValue: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', value)
            },
        },
    },
    methods: {
        onBlurHandler(event) {
            this.$emit('blur', event)
        },
        onSearchHandler(val) {
            this.$emit('on-search', val)
        },
        blur() {
            this.$refs.input.blur();
        },
        focus() {
            this.$refs.input.focus();
        }
    }
}
</script>

<style lang="scss" scoped>
@import 'theme';
</style>
